require("./src/styles/global.css");

require("prismjs/themes/prism.min.css");
require("prismjs/plugins/command-line/prism-command-line.css");
require("prismjs/plugins/line-numbers/prism-line-numbers.css");
require("prism-themes/themes/prism-ghcolors.css");
